import { getFormattedDate } from '../../../../Common/Helper';

export const licensorQuickViewTableConfig = {
    headings: [
        { headingLabel: 'Type', inputType: 'text', width: '5', sortNode: 'type', sortType: 'CustomOrder', sortOrder: ['S', 'M', 'SM', 'G'] },
        { headingLabel: 'Licensor', inputType: 'text', width: '15', sortNode: 'licensorName', sortType: 'Name' },
        { headingLabel: 'Share', inputType: 'text', width: '6', sortNode: 'share', sortType: 'Number' },
        { headingLabel: 'Init. Fee', inputType: 'text', width: '7', sortNode: 'initFee', sortType: 'Number' },
        { headingLabel: 'Status', inputType: 'text', width: '7', sortNode: 'status', sortType: 'Name' },
        { headingLabel: 'Quote Req. Dt', inputType: 'text', width: '10', sortNode: 'quoteRequestDate', sortType: 'Date' },
        { headingLabel: 'License Req. Dt', inputType: 'text', width: '10', sortNode: 'licenseRequestDate', sortType: 'Date' },
        { headingLabel: 'Cue Sheet Pub', inputType: 'text', width: '18', sortNode: 'cueSheetPub', sortType: 'CountThenAlpha', sortSeparator: ' | ' },
        { headingLabel: 'Check Requests', inputType: 'text', width: '16', sortNode: 'checkRequests', sortType: 'CountThenAlpha', sortSeparator: '\n' },
    ],
    dataNodes: [
        'type',
        'licensorName',
        'share',
        'initFee',
        'status',
        'quoteRequestDate',
        'licenseRequestDate',
        'cueSheetPub',
        'checkRequests',
    ],
    primaryKey: 'rowKey',
    badgeNodes: ['type'],
    disabledRowField: 'isDisabled',
    overflowTooltipNodes: ['licensorName', 'cueSheetPub', 'status'],
};

const formatFee = (fee) => {
    if (fee === null || fee === undefined || fee === '') return '';
    const num = Number(fee);
    if (Number.isNaN(num)) return '';
    return `$${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const formatSummaryDate = (date) => getFormattedDate(date) || '';

export const getLicensorTypeAbbrev = (licensorType) => {
    const typeMap = { 1: 'S', 2: 'M', 3: 'SM', 4: 'G', S: 'S', M: 'M', SM: 'SM', G: 'G' };
    return typeMap[licensorType] || '';
};

export const getCheckRequestPayeeNames = (lic, isMainTitle) => {
    const requests = (isMainTitle ? lic?.main_title_check_request : lic?.clearance_check_request) || [];
    const activeRequests = requests.filter((item) => item?.is_delete != 1);
    if (!activeRequests.length) return '';

// Count occurrences of each payee; show "(count)" when a payee appears more than once.    
    const countMap = activeRequests.reduce((acc, cr) => {
        const name = cr?.payee_company || '';
        if (name) acc[name] = (acc[name] || 0) + 1;
        return acc;
    }, {});
    return Object.entries(countMap)
        .map(([name, count], i) => `${i + 1}. ${name}${count > 1 ? ` (${count})` : ''}`)
        .join('\n');
};

export const getCueSheetPublisherSummary = (lic) => {
    const publishers = (lic?.cue_sheet_publishers || []).filter(
        (item) => item?.is_delete != 1 && item?.is_active !== 0
    );
    if (!publishers.length) return '';

    return publishers
        .map((item) => {
            const name = item?.cue_sheet_publisher_name || '';
            const affiliation = item?.affiliation_name?.trim()
                ? ` (${item.affiliation_name.trim()})`
                : '';
            const share = item?.share != null && item?.share !== '' ? ` ${item.share}%` : '';
            return `${name}${affiliation}${share}`.trim();
        })
        .filter(Boolean)
        .join(' | ');
};

export const buildLicensorSummaryRows = (licensors = [], isMainTitle = false) =>
    licensors.map((lic, index) => {
        const initialRight = lic?.rights?.find((right) => right?.is_initial === 1) || lic?.rights?.[0];

        return {
            index,
            rowKey: lic?.clearance_licensor_id || lic?.main_title_licensor_id || `new-${index}`,
            isDisabled: lic?.is_disabled === 1,
            type: getLicensorTypeAbbrev(lic?.licensor_type),
            licensorName: lic?.licensor_name || '',
            share: lic?.share != null && lic?.share !== '' ? `${lic.share}%` : '',
            initFee: formatFee(initialRight?.fee),
            status: lic?.status || '',
            quoteRequestDate: formatSummaryDate(lic?.quote_request_date),
            licenseRequestDate: formatSummaryDate(lic?.license_request_date),
            cueSheetPub: getCueSheetPublisherSummary(lic),
            checkRequests: getCheckRequestPayeeNames(lic, isMainTitle),
        };
    });
